import { get } from "lodash"
import { numberFormatter } from "helpers/formatters/numbers"
import { makeContributorsGroupDropdownSelector } from "helpers/contributors"

const columns = {
  group: [{
    id: "name",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "totalPercentEquity",
    label: "% Equity",
    getter: get,
    formatter: (number) => numberFormatter(number * 100),
  }, {
    id: "value",
    label: "Absolute",
    getter: get,
    formatter: numberFormatter,
  }],
  details: [{
    id: "label",
    label: "",
    align: "left",
    getter: get,
  }, {
    id: "value",
    label: "Exposure (Absolute)",
    getter: get,
    formatter: numberFormatter,
  }],
}

export const getGroupsDropdownColumns = makeContributorsGroupDropdownSelector(columns)
